import { Colors } from '../../../utils/resources/colors';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface ToggleButtonCSSStyle extends UIComponentCSSStyle
{
    getButtonStyle(isSelected:boolean): object;
    getButtonText(isSelected:boolean): object;
    getMobileButtonStyle(isSelected:boolean): object;
    getMobileButtonText(isSelected:boolean): object;
}

export class ToggleButtonCSSStyleImpl extends UIComponentCSSStyleImpl implements ToggleButtonCSSStyle 
{ 
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '46px', 
        // width: '100%', 
        cursor: "default",
        borderRadius:'10px',
        boxShadow:'0 2px 12px 0 rgba(0,0,0,0.1)'
      };
    }

    getButtonStyle(isSelected:boolean): object 
    {
       return {
        // width:'100%',
        height: '43px',
        float: 'left', 
        outline: "none",
        borderRadius: isSelected ? '10px' : "5px",
        boxShadow: isSelected ? '0 2px 12px 0 rgba(0,0,0,0.1)' : '0 0px 0px 0 rgba(0,0,0,0)',
        overflow: 'hidden',
        backgroundColor: isSelected ? this.getResources().getColor(Colors.color_5) : "#EAEDF0",
        cursor: "pointer",
        border: 'none',
        marginTop:'2px',
        marginBottom:'2px',
        marginLeft:'2px',
        marginRight:'2px',
        paddingLeft: "15px",
        paddingRight: "15px",
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
           
      };
    }

    getButtonText(isSelected:boolean): object 
    {
        return {
            color: !isSelected?"#58595B":"#003187", 
            fontSize:'20px', 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "30px",
            textAlign: "center",
            height: "30px",
            paddingTop: "5px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer",
            outline: "none",
            fontWeight:600
       };
     } 

     getMobileButtonText(isSelected:boolean): object 
    {
        return {
            color: !isSelected?"#58595B":"#003187", 
            fontSize:'13px', 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "15px",
            textAlign: "center",
            height: "15px",
            paddingTop: "5px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer",
            outline: "none",
            fontWeight:600
       };
     }

     getMobileButtonStyle(isSelected:boolean): object 
     {
        return {
         // width:'100%',
         height: '43px',
         float: 'left', 
         outline: "none",
         borderRadius: isSelected ? '10px' : "5px",
         boxShadow: isSelected ? '0 2px 12px 0 rgba(0,0,0,0.1)' : '0 0px 0px 0 rgba(0,0,0,0)',
         overflow: 'hidden',
         backgroundColor: isSelected ? this.getResources().getColor(Colors.color_5) : "#EAEDF0",
         cursor: "pointer",
         border: 'none',
         marginTop:'2px',
         marginBottom:'2px',
         marginLeft:'2px',
         marginRight:'2px',
         paddingLeft: "7px",
         paddingRight: "7px",
         alignContent: 'center',
         alignItems: "center",
         justifyContent: "center",
            
       };
     }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebutton/togglebuttoncss.tsx